import script from "./PricingPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingPanel.vue?vue&type=script&setup=true&lang=js"

import "./PricingPanel.vue?vue&type=style&index=0&id=12258d12&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12258d12"]])

export default __exports__